<div>
  <app-nav-bar>
    <main class="container-main">
      <div class="content-wrapper">
        <div
          class="row d-flex justify-content-between row-header-send align-items-end"
        >
          <div class="d-flex flex-column gap-8">
            <button type="button" class="back-button" (click)="closeModal()">
              <img
                src="assets/icons/arrow-left.svg"
                alt="Voltar"
                width="24"
                height="24"
              />
              <span>Voltar</span>
            </button>
            <h2 class="client-name">
              {{ boobleModalData?.companyName || boobleModalData?.name }}
            </h2>
          </div>
        </div>
        <div class="dashboard-cards-container summary-cards-row">
          <mat-card class="summary-card limit-card">
            <mat-card-content>
              <h4 class="card-title">Limite disponível:</h4>
              <div class="limit-content">
                <div class="limit-values-row">
                  <div class="limit-values">
                    <span class="limit-available"
                      >US$
                      {{
                        boobleModalData?.remainingOpLimit || 0
                          | number : "1.2-2"
                      }}</span
                    >
                    <span class="limit-total"
                      >/ US$
                      {{
                        boobleModalData?.opLimit || 0 | number : "1.2-2"
                      }}</span
                    >
                  </div>
                </div>
                <div class="limit-progress">
                  <div class="progress-bar">
                    <div
                      class="progress-fill"
                      [style.width]="getLimitPercentage() + '%'"
                    ></div>
                  </div>
                  <div class="progress-labels">
                    <span class="used-label"
                      >US$
                      {{ getUsedLimit() | number : "1.2-2" }} utilizado</span
                    >
                    <span class="available-label"
                      >{{ getRemainingPercentage() | number : "1.0-0" }}%
                      disponível</span
                    >
                  </div>
                </div>
              </div>
            </mat-card-content>
          </mat-card>

          <mat-card class="summary-card cadastral-card">
            <mat-card-content>
              <h4 class="card-title">Situação do cliente</h4>
              <div class="cadastral-content">
                <div class="info-row">
                  <span class="info-label">Status</span>
                  <div class="status-tags">
                    <span
                      *ngFor="let statusItem of boobleModalData?.status"
                      class="status-tag {{ getStatusClass(statusItem) }}"
                    >
                      {{ getStatusLabel(statusItem) }}
                    </span>
                  </div>
                </div>
                <div class="info-row">
                  <span class="info-label">Data de cadastro:</span>
                  <span class="info-value">{{
                    boobleModalData?.createdDate
                      | date : "dd/MM/yyyy" || "15/03/2022"
                  }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Vencimento:</span>
                  <span class="info-value">{{
                    boobleModalData?.expireAt | date : "dd/MM/yyyy"
                  }}</span>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>

        <mat-tab-group
          class="client-details-tabs"
          [(selectedIndex)]="selectedTabIndex"
        >
          <mat-tab label="Dados gerais">
            <div class="tab-content dados-gerais-content">
              <div class="dados-grid">
                <div class="dados-row">
                  <div class="info-item">
                    <span class="info-label"
                      >{{
                        boobleModalData?.document?.length === 14
                          ? "CNPJ"
                          : "CPF"
                      }}:</span
                    >
                    <div class="info-value-with-icon">
                      <span
                        class="info-value"
                        *ngIf="boobleModalData?.document?.length === 14"
                        >{{
                          boobleModalData?.document
                            | mask : "AA.AAA.AAA/AAAA-00"
                        }}</span
                      >
                      <span
                        class="info-value"
                        *ngIf="boobleModalData?.document?.length === 11"
                        >{{
                          boobleModalData?.document | mask : "000.000.000-00"
                        }}</span
                      >
                      <img
                        src="assets/icons/copy-icon.svg"
                        alt="Copiar"
                        class="copy-icon tappable"
                        width="24"
                        height="24"
                        (click)="copyText(boobleModalData?.document)"
                      />
                    </div>
                  </div>
                  <div class="info-item">
                    <span class="info-label">E-mail:</span>
                    <div class="info-value-with-icon">
                      <span class="info-value">{{
                        boobleModalData?.email
                      }}</span>
                      <img
                        src="assets/icons/copy-icon.svg"
                        alt="Copiar"
                        class="copy-icon tappable"
                        width="24"
                        height="24"
                        (click)="copyText(boobleModalData?.email)"
                      />
                    </div>
                  </div>
                </div>

                <div class="dados-row">
                  <div class="info-item">
                    <span class="info-label">Data de cadastro:</span>
                    <span class="info-value">{{
                      boobleModalData?.createdDate | date : "dd/MM/yyyy"
                    }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">Vencimento:</span>
                    <span class="info-value">{{
                      boobleModalData?.expireAt | date : "dd/MM/yyyy"
                    }}</span>
                  </div>
                </div>

                <div class="dados-row">
                  <div class="info-item">
                    <span class="info-label">Situação cadastro:</span>
                    <div class="situation-status-container">
                      <img
                        [src]="getSituationIcon(boobleModalData.situation)"
                        alt=""
                        class="situation-icon"
                      />
                      <span
                        class="situation-label {{
                          getSituationClass(boobleModalData.situation)
                        }}"
                      >
                        {{ getSituationLabel(boobleModalData.situation) }}
                      </span>
                    </div>
                  </div>
                  <div class="info-item">
                    <span class="info-label">Status:</span>
                    <div class="status-tags">
                      <span
                        *ngFor="let statusItem of boobleModalData?.status"
                        class="status-tag {{ getStatusClass(statusItem) }}"
                      >
                        {{ getStatusLabel(statusItem) }}
                      </span>
                    </div>
                  </div>
                </div>

                <div class="dados-row">
                  <div class="info-item">
                    <span class="info-label">Spread:</span>
                    <span class="info-value"
                      >{{
                        boobleModalData?.isDefaultSpread
                          ? "Padrão"
                          : "Personalizado"
                      }}
                      ({{ boobleModalData?.spread || 0 }}%)</span
                    >
                  </div>
                  <div class="info-item">
                    <span class="info-label">Tarifa:</span>
                    <span class="info-value"
                      >{{
                        boobleModalData?.isDefaultTariff
                          ? "Padrão"
                          : "Personalizada"
                      }}
                      ({{ boobleModalData?.tariff | brl }})</span
                    >
                  </div>
                </div>

                <div class="dados-row">
                  <div class="info-item">
                    <span class="info-label">Endereço:</span>
                    <span class="info-value">{{
                      getFullAddress(
                        this.boobleModalData?.address,
                        this.boobleModalData?.number,
                        this.boobleModalData?.postalCode
                      )
                    }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">Telefone:</span>
                    <div class="info-value-with-icon">
                      <span class="info-value">{{
                        boobleModalData?.phone
                      }}</span>
                      <img
                        src="assets/icons/copy-icon.svg"
                        alt="Copiar"
                        class="copy-icon tappable"
                        width="24"
                        height="24"
                        (click)="copyText(boobleModalData?.phone)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mat-tab>

          <mat-tab
            label="Sócios"
            *ngIf="boobleModalData?.personType === 'PJ - Pessoa Jurídica'"
          >
            <div class="tab-content socios-content">
              <div class="socios-list">
                <div
                  *ngFor="
                    let socio of boobleModalData?.companyResponsibles;
                    let last = last
                  "
                  class="socio-item"
                >
                  <h4 class="socio-name">{{ socio?.name }}</h4>
                  <div class="socio-info-wrap">
                    <div class="socio-info-field">
                      <span class="info-label">CPF:</span>
                      <div class="info-value-container">
                        <span class="info-value">{{
                          socio?.document | mask : "000.000.000-00"
                        }}</span>
                      </div>
                    </div>
                    <div class="socio-info-field">
                      <span class="info-label">Participação societária:</span>
                      <span class="info-value"
                        >{{ socio?.participation || 0 }}%</span
                      >
                    </div>
                    <div class="socio-info-field">
                      <span class="info-label">Assina pela empresa?</span>
                      <span class="info-value">{{
                        socio?.hasCompanyControl ? "Sim" : "Não"
                      }}</span>
                    </div>
                  </div>
                  <ng-container *ngIf="socio?.hasCompanyControl">
                    <div class="socio-info-wrap">
                      <div class="socio-info-field">
                        <span class="info-label">Telefone:</span>
                        <div class="info-value-container">
                          <span class="info-value">{{
                            socio?.phoneNumber | mask : "(00) 00000-0000"
                          }}</span>
                        </div>
                      </div>
                      <div class="socio-info-field">
                        <span class="info-label">E-mail:</span>
                        <span class="info-value">{{ socio?.email }}</span>
                      </div>
                      <div class="socio-info-field">
                        <span class="info-label"
                          >Número de cadastro S.S.N / TIN:</span
                        >
                        <span class="info-value">{{ socio?.fatcaNumber }}</span>
                      </div>
                    </div>
                    <div class="socio-info-wrap">
                      <div class="socio-info-field">
                        <span class="info-label">Endereço:</span>
                        <div class="info-value-container">
                          <span class="info-value">{{
                            getPartnerFullAddress(socio?.address)
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </ng-container>

                  <div *ngIf="!last" class="socio-divider"></div>
                </div>
              </div>
            </div>
          </mat-tab>

          <mat-tab label="Dados bancários" *ngIf="boobleModalData?.bank">
            <div class="tab-content dados-bancarios-content">
              <div class="dados-bancarios-grid">
                <div class="dados-bancarios-row">
                  <div class="info-item">
                    <span class="info-label">Banco:</span>
                    <span class="info-value">{{ boobleModalData?.bank }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">Agência:</span>
                    <span class="info-value">{{
                      boobleModalData?.agency
                    }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">Conta com dígito:</span>
                    <span class="info-value">{{
                      boobleModalData?.account
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </mat-tab>

          <mat-tab label="Configurações">
            <div class="tab-content config-content">
              <form [formGroup]="configForm" class="config-form">
                <div class="config-row">
                  <div class="config-section">
                    <h4 class="config-section-title">Defina o spread</h4>
                    <mat-radio-group
                      formControlName="isDefaultSpread"
                      class="radio-group"
                      (change)="onSpreadChange($event)"
                    >
                      <mat-radio-button [value]="true">
                        Spread padrão
                      </mat-radio-button>
                      <mat-radio-button [value]="false">
                        Spread personalizado
                      </mat-radio-button>
                    </mat-radio-group>

                    <mat-form-field appearance="outline" class="config-input">
                      <mat-label>Spread *</mat-label>
                      <input
                        matInput
                        type="text"
                        formControlName="spread"
                        currencyMask
                        [options]="{
                          prefix: '',
                          thousands: '.',
                          decimal: ',',
                          suffix: ' %',
                          align: 'left'
                        }"
                      />
                      <mat-error>Spread personalizado obrigatório</mat-error>
                    </mat-form-field>
                  </div>

                  <div class="config-section">
                    <h4 class="config-section-title">Defina a tarifa</h4>
                    <mat-radio-group
                      formControlName="isDefaultTariff"
                      class="radio-group"
                      (change)="onTariffChange($event)"
                    >
                      <mat-radio-button [value]="true">
                        Tarifa padrão
                      </mat-radio-button>
                      <mat-radio-button [value]="false">
                        Tarifa personalizada
                      </mat-radio-button>
                    </mat-radio-group>

                    <mat-form-field appearance="outline" class="config-input">
                      <mat-label>Tarifa *</mat-label>
                      <input
                        matInput
                        type="text"
                        formControlName="tariff"
                        currencyMask
                        [options]="{
                          prefix: 'R$ ',
                          thousands: '.',
                          decimal: ',',
                          align: 'left'
                        }"
                      />
                      <mat-error>Tarifa personalizada obrigatória</mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <div class="config-row">
                  <div class="config-section">
                    <h4 class="config-section-title">Defina a agência</h4>
                    <mat-form-field appearance="outline" class="config-input">
                      <mat-label>Agência</mat-label>
                      <mat-select
                        formControlName="businessPartnerId"
                        #agencySelect
                      >
                        <mat-option disabled class="search-option">
                          <ngx-mat-select-search
                            placeholderLabel="Pesquisar agência"
                            noEntriesFoundLabel="Nenhum resultado encontrado"
                            [formControl]="agencyFilterCtrl"
                          >
                          </ngx-mat-select-search>
                        </mat-option>

                        <mat-option
                          *ngFor="let ag of filteredAgencies | async"
                          [value]="ag.id"
                        >
                          Ag {{ ag.agencyNumber }} - {{ ag.companyName }}
                        </mat-option>
                      </mat-select>
                      <mat-error>Agência obrigatória</mat-error>
                    </mat-form-field>
                  </div>

                  <div class="config-section">
                    <h4 class="config-section-title">Defina o perfil</h4>
                    <mat-form-field appearance="outline" class="config-input">
                      <mat-label>Perfil</mat-label>
                      <mat-select formControlName="profileType">
                        <mat-option value="Administrador"
                          >Administrador</mat-option
                        >
                        <mat-option value="Cliente">Cliente</mat-option>
                      </mat-select>
                      <mat-error>Perfil obrigatório</mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <div class="config-actions">
                  <button
                    type="button"
                    class="btn-save-config"
                    [disabled]="configForm.invalid || loading"
                    (click)="sendConfig()"
                  >
                    Salvar configurações
                    <span
                      class="spinner-border spinner-border-sm"
                      *ngIf="loading"
                    ></span>
                  </button>
                </div>
              </form>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>

      <mat-card class="historico-card" *ngIf="haveLog">
        <mat-card-content>
          <h4 class="card-title">Histórico de movimentação</h4>
          <app-table-clients-log-admin
            [displayedColumns]="logDisplayedColumns"
            [data]="logData"
            [pageNumber]="logPageNumber"
            [pageSize]="logPageSize"
            [totalElements]="logTotalElements"
            (pageChange)="updateLogPageData($event)"
          ></app-table-clients-log-admin>
        </mat-card-content>
      </mat-card>
    </main>
  </app-nav-bar>
</div>
